import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main/Main';

export const AIAssistants = () => (
  <>
    <DocumentHead title='AI Assistants' />
    <PageTemplate main={<Main />} />
  </>
);
